import { CHECKEDPOI } from "../../actions/portal/";

export default function(state = false, action){
  switch (action.type) {
    case CHECKEDPOI:
    return action.payload;
    default:
  }

  return state;
}
